import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

const CollectionsPage = lazy(() =>
  import('./routes/CollectionsPage').then((m) => ({ default: m.CollectionsPage })),
);

/**
 * The Collections screen, at `/assets/collections`.
 *
 * <p>**Listed inside the `<ProductRoute />` group in `app/router`**, before `placeholderRoutes`,
 * whose entry for this path is gone now that this exists. The path names no product, so the
 * guard passes it straight through.
 */
export const collectionsRoutes: RouteObject[] = [
  { path: ROUTES.collections, element: <CollectionsPage /> },
];
